var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1082,
    height: 1082,
    viewBox: "0 0 1082 1082",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97097 468.806C-30.004 762.289 175.492 1032.62 468.975 1072.59C671.015 1100.12 871.181 1010.72 985.485 841.864L918.943 811.717",
    stroke: "white",
    strokeWidth: 8.32812,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.6 614.674C1113.11 321.274 908.115 50.5688 614.674 10.0525C412.009 -17.93 211.094 71.8471 96.707 241.449L163.832 271.805",
    stroke: "white",
    strokeWidth: 8.32812,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinee);
export default __webpack_public_path__ + "static/media/outline 'e'.c87aea2812dcf95cb0e12063e761c1fd.svg";
export { ForwardRef as ReactComponent };